import { render } from "./Olbersleben.vue?vue&type=template&id=414d72d1"
import script from "./Olbersleben.vue?vue&type=script&lang=js"
export * from "./Olbersleben.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__